import { useState, useEffect } from "react";
import { Main, Content } from "../../components/Layout";
import api from "../../services/api";
import { Row, Col, Form } from "react-bootstrap";
import Checkbox from "../../components/Checkbox";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import moment from "moment";
import Wizard from "../../components/Wizard";
import styleButton from "../../components/Button/Button.module.css";
import Slct from "../../components/Slct";
import DatePicker from "../../components/DatePicker";
import { IntegerNumber, Phone, InputText, InputEmail } from "../../components/Input";
import getCommercial from "../../util/getCommercial";
import Loading from "../../components/Loading";
import { ModalConfirm } from "../../components/Modal";
import { formatDate } from "../../util/functions";
import useWrapper from "../../hooks/useWrapper";
import { validateForm } from "../../components/ValidateForm";
import Required from "../../components/Required";
import Button from "../../components/Button";
import useFormat from "../../hooks/utils/useFormat";

export default function Business() {
  const { businessId } = useParams();
  const { setbreadcrumb, config, me } = useWrapper();
  const navigate = useNavigate();

  const { stringToDate } = useFormat();

  const [isLoadingStartup, setisLoadingStartup] = useState(true);
  const [isLoadingRequest, setisLoadingRequest] = useState();
  const [isWaitingResponse, setisWaitingResponse] = useState(false);

  useEffect(() => {
    setisWaitingResponse(isLoadingStartup || isLoadingRequest);
  }, [isLoadingStartup, isLoadingRequest]);

  const [pageloaded, setpageloaded] = useState(false);
  const [institutions, setinstitutions] = useState([]);
  const [categories, setcategories] = useState([]);
  const [courses, setCourses] = useState([]);
  const [packages, setPackages] = useState([
    {
      name: "",
      number_trainees: null,
      events: [],
      active: true,
    },
  ]);

  const [legacy, setlegacy] = useState({
    is_legacy: false,
  });
  const [commercialRaw, setcommercialRaw] = useState(null);
  const [commercial, setCommercial] = useState({
    institution_id: "",
    courser_id: "",
    year: "",
    period: "",
    max_people: "",
    due_date: "",
    total_trainees: "",
    invites_trainees: "",
    ticket_trainees: "",
    digital_invite: "",
    channel_marketing: "",
    ideal_payment: "",
    min_payment: 0,
    status: "",
    comission: [
      {
        name: "",
        email: "",
        cell: "",
        is_whatsapp: false,
      },
    ],
    legacy_id: null,
  });

  const [wizard, setWizard] = useState(1);
  const [lastPayment, setlastPayment] = useState();
  useEffect(() => {
    (async () => {
      try {
        setisLoadingStartup(true);
        const { data: _institutions } = await api.get("institutions?paginate=false", config);

        setinstitutions(
          _institutions?.map(__institution => ({
            value: __institution?.id,
            label: __institution?.title,
            courses: __institution?.courses?.map(__course => ({
              value: __course?.id,
              label: __course?.title,
            })),
          })),
        );

        const { data: _categories } = await api.get("categories?only_attendance=0", config);
        setcategories(_categories?.data);

        if (window.location.hash === "#is_class" && !!businessId) {
          const { data: _last_payment_data } = await api.get(`paymentslips/last-payment/report/${businessId}`, config);

          const _last_payment = !_last_payment_data?.last_date ? null : stringToDate(_last_payment_data?.last_date);

          setlastPayment(_last_payment);
        }
        if (!!businessId) {
          const _commercial = await getCommercial(businessId);
          setcommercialRaw(_commercial);
        }
      } catch (__error) {
        toast.error("Ocorreu um erro ao carregar os dados.");
        setisLoadingStartup(false);
        console.log("__error", __error);
      } finally {
        setisLoadingStartup(false);
      }
    })();
  }, []);
  useEffect(() => {
    if (businessId) {
      if (!!institutions.length && !!categories.length && commercialRaw) {
        setpageloaded(true);
      }
    } else {
      setpageloaded(true);
    }
  }, [institutions, courses, categories]);

  useEffect(() => {
    if (businessId && commercialRaw) {
      setCommercial({
        ...commercial,
        institution_id: commercialRaw.institution.id,
        courser_id: commercialRaw.institution.course.id,
        year: commercialRaw.institution.year,
        period: commercialRaw.institution.period,
        ...(!!commercialRaw.comission.length && { comission: commercialRaw.comission }),
        date_start: stringToDate(commercialRaw.negotiation.quota_first),
        date_end: stringToDate(commercialRaw.negotiation.quota_last),
        min_payment: commercialRaw.negotiation.quotas,
        total_trainees: commercialRaw.negotiation.total_trainees,
        channel_marketing: commercialRaw.negotiation.channel_marketing,
        ideal_payment: commercialRaw.negotiation.ideal_payment,
        legacy_id: commercialRaw.legacy_id,
        became_class: commercialRaw.became_class ? stringToDate(commercialRaw.became_class) : null,
        whatsapp_link: commercialRaw.whatsapp_link,
        contract_number_legacy: commercialRaw.contract_number_legacy,
        invites_trainees: commercialRaw.invites_trainees,
        ticket_trainees: commercialRaw.ticket_trainees,
      });
      !!commercialRaw.legacy_id && setlegacy({ is_legacy: true });
      setcategories(
        categories.map(e => ({
          ...e,
          event: e.event.map(e2 => {
            let _event = commercialRaw.packages_data.events.find(e3 => e3.id === e2.id);
            let _is_single = commercialRaw.packages_data.singles.find(e3 => e3.event_id === e2.id);
            return {
              ...e2,
              checked: !!_event,
              date: _event ? _event.date_event : null,
              is_single: !!_is_single,
              ...(_is_single && { is_single_trainees: _is_single.number_trainees }),
              ...(_is_single && { is_single_id: _is_single.id }),
              locked_event: _event ? true : false,
              locked_single: _is_single ? true : false,
            };
          }),
        })),
      );
      setPackages(
        commercialRaw.packages_data.packages.map(e => ({
          id: e.id,
          name: e.name,
          number_trainees: e.number_trainees,
          active: true,
          events: e.events.map(e2 => ({
            label: e2.name,
            value: e2.id,
          })),
          // locked: true
        })),
      );
    }
  }, [commercialRaw]);

  useEffect(() => {
    calculaParcelas();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [commercial.date_end, commercial.date_start]);

  function calculaParcelas() {
    let dataStart = moment(commercial.date_start, "DD-MM-YYYY").toDate();
    let dataFim = moment(commercial.date_end, "DD-MM-YYYY").toDate();

    if (dataStart !== "Invalid Date" && dataFim !== "Invalid Date") {
      let monthDifference = moment(dataFim).diff(dataStart, "months", true);
      if (monthDifference < 0) {
        setCommercial({
          ...commercial,
          date_end: "",
          min_payment: "",
        });
        toast.error("Data final não pode ser menor que a data inicial");
      } else {
        if (monthDifference === 0) {
          monthDifference = 1;
        } else {
          if (monthDifference > 0 && monthDifference < 1) {
            monthDifference = 2;
          } else {
            monthDifference = monthDifference + 1;
          }
        }
        setCommercial({
          ...commercial,
          min_payment: parseInt(monthDifference),
        });
      }
    }
  }

  const advanceStep = async __step => {
    if (__step < wizard && __step >= 0) {
      setWizard(__step);
      return;
    }

    const _is_valid = validateForm(
      window.location.hash === "#commercial"
        ? document.getElementById("commercial_container")
        : document.getElementById("all_container"),
    );
    if (!_is_valid) return;

    if (__step === "save") {
      setisLoadingRequest(true);
      let _events = [];
      let _singles = [];

      categories.forEach(e => {
        e.event.forEach(e2 => {
          if (e2.checked) {
            _events.push({
              event_id: e2.id,
              due_date: e2.date ? stringToDate(e2.date) : null,
            });
          }
          if (e2.is_single) {
            _singles.push({
              ...(e2.is_single_id && { id: e2.is_single_id }),
              event_id: e2.id,
              number_trainees: e2.is_single_trainees,
            });
          }
        });
      });
      const _data = {
        channel_marketing: commercial?.channel_marketing,
        courser_id: commercial?.courser_id,
        date_end: commercial?.date_end,
        date_start: commercial?.date_start,
        digital_invite: commercial?.digital_invite,
        ideal_payment: commercial?.ideal_payment,
        institution_id: commercial?.institution_id,
        invites_trainees: commercial?.invites_trainees,
        max_people: commercial?.max_people,
        min_payment: commercial?.min_payment,
        eventDate: _events,
        whatsapp_link: commercial?.whatsapp_link,
        packages: packages?.map(__package => ({
          id: __package?.id,
          name: __package?.name,
          active: __package?.active,
          number_trainees: __package?.number_trainees,
          events:
            __package?.events.map(e2 => ({
              event_id: e2.value,
            })) || [],
        })),
        period: commercial?.period,
        single: _singles,
        ticket_trainees: commercial?.ticket_trainees,
        invites_trainees: commercial?.invites_trainees,
        total_trainees: commercial?.total_trainees,
        tempTrainees: commercial?.comission.map(__member => ({
          name: __member?.name,
          email: __member?.email,
          cell: __member?.cell,
          courser_id: commercial?.courser_id,
          is_whatsapp: __member?.is_whatsapp,
          institution_id: commercial?.institution_id,
          year: commercial?.year,
          is_member: true,
        })),
        year: commercial?.year,
        ...(!!acceptDateProblem && {
          user_id_accept_date: me?.id,
          accept_date: new Date(),
          accept_date_status: true,
        }),
        legacy_id: commercial?.legacy_id,
        became_class: commercial?.became_class,
        contract_number_legacy: commercial?.contract_number_legacy,
      };

      try {
        if (businessId) {
          await api.put(`commercial/${businessId}`, _data, config);
          toast.success("Negociação Editada com Sucesso!");
          navigate(
            window.location.hash === "#is_class"
              ? `/groups/${businessId}/registrationdata`
              : `/business/feed/${businessId}`,
          );
        } else {
          await api.post(
            "commercial",
            {
              ..._data,
              step_id: 1,
            },
            config,
          );
          toast.success("Negociação Criada com Sucesso!");
          navigate(`/business/filter`);
        }
      } catch (__error) {
        toast.error("Ocorreu um erro ao salvar os dados.");
        setisLoadingRequest(false);
        console.log("__error", __error);
      }
    } else {
      setWizard(__step);
    }
  };

  useEffect(() => {
    if (commercial.institution_id) {
      setCourses(institutions.find(e => e.value === commercial.institution_id).courses);
    }
  }, [commercial.institution_id]);

  const [dateProblem, setdateProblem] = useState();
  const [acceptDateProblem, setacceptDateProblem] = useState(false);

  useEffect(() => {
    if (commercialRaw) {
      if (commercialRaw.is_class) {
        setbreadcrumb([
          { label: "Turmas", url: "/groups" },
          {
            ...(!!commercialRaw?.institution
              ? {
                  label: commercialRaw?.institution.name,
                  url: `/groups/${commercialRaw.id}/registrationdata`,
                }
              : { label: "Nova Negociação" }),
          },
          { ...(!!commercialRaw?.institution && { label: "Editar Pacotes/Dados" }) },
        ]);
      } else {
        setbreadcrumb([
          { label: "Comercial", url: "/business" },
          {
            ...(!!commercialRaw?.institution
              ? {
                  label: commercialRaw?.institution.name,
                  url: `/business/feed/${commercialRaw.id}`,
                }
              : { label: "Nova Negociação" }),
          },
          { ...(!!commercialRaw?.institution && { label: "Editar Pacotes/Dados" }) },
        ]);
      }
    }
  }, [commercialRaw]);

  return (
    <>
      <Main>
        {pageloaded ? (
          <Content>
            {window.location.hash === "#is_class" && (
              <Wizard
                className="mb-4"
                selected={wizard}
                options={[
                  { label: "Dados de Cadastro", onClick: () => advanceStep(1) },
                  { label: "Formação de Pacotes", onClick: () => advanceStep(2) },
                ]}
              />
            )}

            <Form id="all_container">
              {wizard === 1 ? (
                <div id="commercial_container">
                  <Row>
                    <Col md={6}>
                      <Row className="mb-3">
                        <Col>
                          <h3 className="form-title">Dados da Turma</h3>
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <span>
                            Instituição <Required />
                          </span>
                          <Slct
                            required={true}
                            options={institutions}
                            value={commercial?.institution_id || ""}
                            onChange={__ev => {
                              setCommercial({
                                ...commercial,
                                institution_id: __ev.value,
                                courser_id: null,
                              });
                            }}
                            placeholder="..."
                          />
                        </Col>
                      </Row>
                      <Row className="mt-2">
                        <Col>
                          <span>
                            Curso <Required />
                          </span>
                          <Slct
                            required={true}
                            options={courses}
                            value={commercial?.courser_id || ""}
                            onChange={__ev => {
                              setCommercial({
                                ...commercial,
                                courser_id: __ev.value,
                              });
                            }}
                            placeholder="..."
                          />
                        </Col>

                        <Col className="flex">
                          <span>
                            Ano/Período <Required />
                          </span>
                          <div className="ano-periodo">
                            <IntegerNumber
                              required={true}
                              value={commercial?.year}
                              valueChange={__ev => {
                                setCommercial({
                                  ...commercial,
                                  year: __ev || "",
                                });
                              }}
                              maxlength="4"
                            />
                            <Slct
                              required={true}
                              options={[
                                { value: 1, label: "1" },
                                { value: 2, label: "2" },
                              ]}
                              value={commercial?.period || ""}
                              onChange={__ev => {
                                setCommercial({
                                  ...commercial,
                                  period: __ev.value,
                                });
                              }}
                              placeholder="..."
                            />
                          </div>
                        </Col>
                      </Row>
                      <Row className="mt-2">
                        <Col>
                          <span>Apelido da Turma</span>
                          <InputText
                            value={commercial?.contract_number_legacy}
                            onChange={__ev => {
                              setCommercial({
                                ...commercial,
                                contract_number_legacy: __ev.target.value,
                              });
                            }}
                          />
                        </Col>
                        <Col>
                          <span>Grupo do Whatsapp</span>
                          <InputText
                            value={commercial?.whatsapp_link}
                            onChange={__ev => {
                              setCommercial({
                                ...commercial,
                                whatsapp_link: __ev.target.value,
                              });
                            }}
                          />
                        </Col>
                      </Row>
                      <Row className="mt-3 mb-3">
                        <Col>
                          <h3 className="form-title">Comissão</h3>
                        </Col>
                      </Row>
                      {commercial?.comission?.map((__member, __member_i) => (
                        <div
                          className="mt-3"
                          style={{ borderLeft: "var(--color-grey-3) 3px solid", paddingLeft: "1rem" }}
                        >
                          <Row>
                            <Col>
                              <span>
                                Nome <Required />
                              </span>
                              <InputText
                                required={true}
                                value={__member.name}
                                onChange={__ev => {
                                  let _comission = [...commercial.comission];
                                  _comission[__member_i].name = __ev.target.value;
                                  setCommercial({
                                    ...commercial,
                                    comission: _comission,
                                  });
                                }}
                              />
                            </Col>
                          </Row>
                          <Row className="mt-2">
                            <Col>
                              <span>
                                E-mail <Required />
                              </span>
                              <InputEmail
                                required={true}
                                value={__member.email}
                                onChange={__ev => {
                                  let _comission = [...commercial.comission];
                                  _comission[__member_i].email = __ev.target.value;
                                  setCommercial({
                                    ...commercial,
                                    comission: _comission,
                                  });
                                }}
                                placeholder="usuario@email.com"
                              />
                            </Col>
                            <Col>
                              <div className="position-relative">
                                <span>
                                  Celular <Required />
                                </span>
                                <Phone
                                  required={true}
                                  value={__member.cell}
                                  valueChange={__ev => {
                                    let _comission = [...commercial.comission];
                                    _comission[__member_i].cell = __ev;
                                    setCommercial({
                                      ...commercial,
                                      comission: _comission,
                                    });
                                  }}
                                />
                                <label className="im-checkbox-2">
                                  <Checkbox
                                    name="is_whatsapp"
                                    checked={__member?.is_whatsapp || 0}
                                    onChange={__ev => {
                                      let _comission = [...commercial.comission];
                                      _comission[__member_i].is_whatsapp = __ev.target.checked;
                                      setCommercial({
                                        ...commercial,
                                        comission: _comission,
                                      });
                                    }}
                                  />
                                  <span className="fs-12">WhatsApp?</span>
                                </label>
                              </div>
                            </Col>
                          </Row>
                          <Row className="mt-2">
                            <Col className="d-flex justify-content-end align-items-end">
                              {commercial?.comission?.length > 1 && (
                                <button
                                  type="button"
                                  className={styleButton.button_error_soft}
                                  onClick={() => {
                                    let _comission = [...commercial.comission];
                                    _comission.splice(__member_i, 1);
                                    setCommercial({
                                      ...commercial,
                                      comission: _comission,
                                    });
                                  }}
                                >
                                  <span>Remover</span>
                                </button>
                              )}
                            </Col>
                          </Row>
                        </div>
                      ))}
                      <Row className="mt-3">
                        <Col>
                          <button
                            type="button"
                            className={styleButton.button_success_soft}
                            onClick={() => {
                              setCommercial({
                                ...commercial,
                                comission: [
                                  ...commercial.comission,
                                  {
                                    name: "",
                                    email: "",
                                    cell: "",
                                    is_whatsapp: false,
                                  },
                                ],
                              });
                            }}
                          >
                            <span>Adicionar</span>
                          </button>
                        </Col>
                      </Row>
                    </Col>
                    <Col md={6} className="pl-md-5">
                      <Row>
                        <Col>
                          <h3 className="form-title mb-3">Dados do Contrato</h3>
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <span>
                            Data da Primeira Parcela <Required />
                          </span>
                          <DatePicker
                            required={true}
                            selected={commercial?.date_start || ""}
                            changeDate={ev => {
                              setCommercial({
                                ...commercial,
                                date_start: ev,
                              });
                            }}
                          />
                        </Col>
                        <Col>
                          <span>
                            Data da Última Parcela <Required />
                          </span>
                          <DatePicker
                            required={true}
                            selected={commercial?.date_end || commercial?.date_start || ""}
                            changeDate={async __ev => {
                              let _last_date = __ev || commercial?.date_start;
                              if (_last_date) {
                                const _can = await api.get(
                                  `paymentslips/verify-payment/report?commercial_id=${businessId}&dueStart=${formatDate(
                                    _last_date,
                                    3,
                                  )}`,
                                  config,
                                );
                                if (_can.data.Success) {
                                  setCommercial({
                                    ...commercial,
                                    date_end: _last_date,
                                  });
                                } else {
                                  setdateProblem({
                                    newDate: _last_date,
                                    lastPayment: _can.data.LastDate,
                                    next: () => {
                                      setCommercial({
                                        ...commercial,
                                        date_end: _last_date,
                                      });
                                    },
                                  });
                                }
                              }
                            }}
                          />
                        </Col>
                      </Row>
                      <Row className="mt-2">
                        <Col>
                          <span>Qnt. Máxima de Parcelas</span>
                          <IntegerNumber value={commercial?.min_payment} valueChange={() => {}} disabled={true} />
                        </Col>
                        <Col>
                          <span>
                            Formandos Previstos <Required />
                          </span>
                          <IntegerNumber
                            required={true}
                            value={commercial?.total_trainees}
                            valueChange={__ev => {
                              setCommercial({
                                ...commercial,
                                total_trainees: __ev,
                              });
                            }}
                            maxlength="4"
                          />
                        </Col>
                      </Row>
                      <Row className="mt-2">
                        <Col>
                          <span>Ingressos</span>
                          <IntegerNumber
                            value={commercial?.ticket_trainees || 0}
                            valueChange={__ev => {
                              setCommercial({
                                ...commercial,
                                ticket_trainees: __ev,
                              });
                            }}
                            maxlength="4"
                          />
                        </Col>
                        <Col>
                          <span>Convites</span>
                          <IntegerNumber
                            value={commercial?.invites_trainees || 0}
                            valueChange={__ev => {
                              setCommercial({
                                ...commercial,
                                invites_trainees: __ev,
                              });
                            }}
                            maxlength="4"
                          />
                        </Col>
                      </Row>
                      <Row className="mt-2">
                        <Col>
                          <span>
                            Através de qual canal o formando conheceu a empresa? <Required />
                          </span>
                          <Slct
                            options={[
                              { value: "google", label: "Através do Google" },
                              { value: "instagram", label: "Através do Instagram" },
                              { value: "facebook", label: "Através do  Facebook" },
                              { value: "youtube", label: "Através do  Youtube" },
                              { value: "empresa", label: "Através do  Site da empresa" },
                              { value: "amigos", label: "Indicação de amigos e conhecidos" },
                              { value: "eventos", label: "Através de eventos" },
                              { value: "instituição", label: "Através da instituição de ensino" },
                              { value: "outro", label: "Outro" },
                            ]}
                            value={commercial?.channel_marketing}
                            onChange={__ev => {
                              setCommercial({
                                ...commercial,
                                channel_marketing: __ev.value,
                              });
                            }}
                            placeholder="..."
                            required={true}
                          />
                        </Col>
                      </Row>
                      <Row className="mt-2">
                        <Col>
                          <span className="lince-input_label">
                            Qual seria o valor ideal da parcela para a turma? Lembrando que quanto antes o contrato for
                            fechado, menor será a parcela. <Required />
                          </span>
                          <Slct
                            options={[
                              { value: "100", label: "Até R$100,00" },
                              { value: "150", label: "Entre R$100,00 e R$149,00" },
                              { value: "199", label: "Entre R$150,00 e R$199,00" },
                              { value: "249", label: "Entre R$200,00 e R$249,00" },
                              { value: "250", label: "Acima de R$250,00" },
                            ]}
                            value={commercial?.ideal_payment}
                            onChange={__ev => {
                              setCommercial({
                                ...commercial,
                                ideal_payment: __ev.value,
                              });
                            }}
                            placeholder="..."
                            required={true}
                          />
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  <Row className="mt-3">
                    <Col>
                      <label>
                        <Checkbox
                          className="mr-2"
                          colorScheme="primary"
                          checked={legacy.is_legacy}
                          onChange={() => {
                            setlegacy({
                              is_legacy: !legacy.is_legacy,
                            });
                          }}
                        />
                        <span>Turma Legado</span>
                      </label>
                    </Col>
                  </Row>
                  <Row className="mt-3">
                    {!!legacy.is_legacy && (
                      <>
                        <Col sm={4}>
                          <span>
                            ID no Sistema Legado <Required />
                          </span>
                          <IntegerNumber
                            value={commercial?.legacy_id}
                            valueChange={__ev => {
                              setCommercial({
                                ...commercial,
                                legacy_id: __ev,
                              });
                            }}
                            maxlength="10"
                            required={true}
                          />
                        </Col>
                        <Col sm={4}>
                          <span>
                            Data do Contrato <Required />
                          </span>
                          <DatePicker
                            selected={commercial?.became_class}
                            changeDate={__ev => {
                              setCommercial({
                                ...commercial,
                                became_class: __ev,
                              });
                            }}
                            required={true}
                          />
                        </Col>
                      </>
                    )}
                  </Row>
                </div>
              ) : (
                <Row className="inner-page__sbs-border mt-3">
                  <Col md={6}>
                    <Row>
                      <Col>
                        <h2 className="form-title">Eventos Inclusos</h2>
                        <p className="small-label mb-0">
                          Defina as Datas dos Eventos que farão parte dos pacotes oferecidos para a turma.
                        </p>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        {categories?.map((__category, __category_i) => {
                          return (
                            <>
                              {!!__category.event.length && (
                                <div className="">
                                  <p className="mt-4 mb-0">{__category.name}</p>
                                  {__category.event.map((__event, __event_i) => (
                                    <div
                                      className={`mt-2 d-flex justify-content-between align-items-stretch ${styleButton.input_button_list}`}
                                      date-border={__event.checked ? "primary" : ""}
                                    >
                                      <div className="d-flex align-items-center">
                                        {!__event.locked_event && (
                                          <Checkbox
                                            disabled={__event.locked_event}
                                            checked={__event.checked}
                                            name="categories[].event[].checked"
                                            onChange={__ev => {
                                              let _categories = [...categories];
                                              _categories[__category_i].event[__event_i].checked = __ev.target.checked;
                                              setcategories(_categories);
                                            }}
                                          />
                                        )}
                                        <span className="ml-2" style={{ opacity: __event.checked ? 1 : 0.333 }}>
                                          {__event.name}
                                        </span>
                                      </div>
                                      {__event.checked && (
                                        <div
                                          style={{
                                            borderLeft: "1px solid var(--color-grey-4)",
                                            width: "120px",
                                            display: "flex",
                                            alignItems: "center",
                                          }}
                                        >
                                          <DatePicker
                                            required={true}
                                            selected={!!__event.date ? __event.date : ""}
                                            name="categories[].date"
                                            placeholderText={"Data Prevista"}
                                            changeDate={async __ev => {
                                              if (!!__ev) {
                                                let _categories = [...categories];
                                                _categories[__category_i].event[__event_i].date = __ev;
                                                const _all_events = _categories
                                                  ?.reduce((__acc, __category) => __acc.concat(__category?.event), [])
                                                  ?.map(__event => __event.date)
                                                  ?.filter(__event => !!__event);

                                                if (
                                                  !lastPayment ||
                                                  _all_events?.some(__event => __event > lastPayment)
                                                ) {
                                                  setcategories(_categories);
                                                } else {
                                                  setTimeout(() => {
                                                    setdateProblem({
                                                      newDate: __ev,
                                                      lastPayment: lastPayment,
                                                      next: () => {
                                                        let _categories = [...categories];
                                                        _categories[__category_i].event[__event_i].date = __ev;
                                                        setcategories(_categories);
                                                      },
                                                    });
                                                  }, 0);
                                                }
                                              }
                                            }}
                                            className="text-right"
                                          />
                                        </div>
                                      )}
                                    </div>
                                  ))}
                                </div>
                              )}
                            </>
                          );
                        })}
                      </Col>
                    </Row>
                  </Col>
                  <Col>
                    <Row className="mb-3">
                      <Col>
                        <h3 className="form-title">Pacotes</h3>
                        <p className="small-label mb-2">
                          Para otimizar o processo de vendas, recomendamos a criação de 2 pacotes principais: Um mais
                          básico e outro completo. Além disso, você também pode criar eventos de adesão avulsa que podem
                          ser vendidos em qualquer momento durante a jornada da turma na empresa.
                        </p>
                      </Col>
                    </Row>
                    {packages.map((e, i) => (
                      <>
                        {!!e.active && (
                          <div style={{ borderLeft: "var(--color-grey-3) 3px solid", paddingLeft: "1rem" }}>
                            <Row className="mt-3">
                              <Col>
                                <span>
                                  Nome do Pacote <Required />
                                </span>

                                <InputText
                                  required={true}
                                  value={packages[i].name}
                                  onChange={__ev => {
                                    let _packages = [...packages];
                                    _packages[i].name = __ev.target.value;
                                    setPackages(_packages);
                                  }}
                                />
                              </Col>
                              <Col>
                                <span>
                                  Quantidade de Formandos <Required />
                                </span>
                                <IntegerNumber
                                  value={packages[i].number_trainees}
                                  valueChange={__ev => {
                                    let _packages = [...packages];
                                    _packages[i].number_trainees = __ev;
                                    setPackages(_packages);
                                  }}
                                  maxlength="10"
                                  required={true}
                                />
                              </Col>
                            </Row>
                            <Row className="mt-2">
                              <Col>
                                <span>
                                  Eventos Inclusos <Required />
                                </span>
                                <Slct
                                  options={categories.reduce(
                                    (p, e) =>
                                      p.concat(
                                        e.event
                                          .filter(e2 => e2.checked)
                                          .map(e2 => ({
                                            label: e2.name,
                                            value: e2.id,
                                          })),
                                      ),
                                    [],
                                  )}
                                  placeholder="..."
                                  isMulti="true"
                                  value={e.events}
                                  onChange={__ev => {
                                    let _packages = [...packages];
                                    _packages[i].events = __ev;
                                    setPackages(_packages);
                                  }}
                                  required={true}
                                />
                              </Col>
                            </Row>

                            <Row className="mb-3 mt-2">
                              <Col className="d-flex align-items-center justify-content-end">
                                {packages.length > 1 && (
                                  <button
                                    onClick={() => {
                                      let _packages = [...packages];
                                      if (!!_packages[i].id) {
                                        _packages[i].active = false;
                                      } else {
                                        _packages.splice(i, 1);
                                      }
                                      setPackages(_packages);
                                    }}
                                    type="button"
                                    className={styleButton.button_error_soft}
                                  >
                                    <span>Remover</span>
                                  </button>
                                )}
                              </Col>
                            </Row>
                          </div>
                        )}
                      </>
                    ))}
                    <Row>
                      <Col>
                        <button
                          type="button"
                          onClick={() => {
                            setPackages([
                              ...packages,
                              {
                                name: "",
                                number_trainees: null,
                                events: [],
                                active: true,
                              },
                            ]);
                          }}
                          className={styleButton.button_success_soft}
                        >
                          <span>Adicionar Pacote</span>
                        </button>
                      </Col>
                    </Row>
                    <Row className="mt-3">
                      <Col>
                        <h3 className="form-title">Eventos Avulsos</h3>
                        <p className="small-label mb-2">
                          Selecione Eventos que podem ser selecionados sem possuir vínculo com pacotes.
                        </p>
                        {categories.map((e, i) => (
                          <>
                            {e.event.map((e2, i2) => (
                              <>
                                {e2.checked && (
                                  <div
                                    className={`mt-2 d-flex justify-content-between align-items-stretch ${styleButton.input_button_list}`}
                                    date-border={e2.is_single ? "primary" : ""}
                                  >
                                    <div className="d-flex align-items-center">
                                      {!e2.locked_single && (
                                        <Checkbox
                                          disabled={e2.locked_single}
                                          checked={e2.is_single}
                                          name="categories[].event[].is_single"
                                          onChange={ev => {
                                            let _categories = [...categories];
                                            _categories[i].event[i2].is_single = ev.target.checked;
                                            setcategories(_categories);
                                          }}
                                        />
                                      )}
                                      <span className="ml-2" style={{ opacity: e2.is_single ? 1 : 0.333 }}>
                                        {e2.name}
                                      </span>
                                    </div>
                                    {e2.is_single && (
                                      <div
                                        style={{
                                          borderLeft: "1px solid var(--color-grey-4)",
                                          width: "160px",
                                          display: "flex",
                                          alignItems: "center",
                                        }}
                                      >
                                        <IntegerNumber
                                          placeholderText={"..."}
                                          value={e2.is_single_trainees || null}
                                          valueChange={ev => {
                                            let _categories = [...categories];
                                            _categories[i].event[i2].is_single_trainees = ev;
                                            setcategories(_categories);
                                          }}
                                          className="text-right"
                                          suffix={" formandos"}
                                          placeholder="0 formandos"
                                          name="categories[].is_single_trainees"
                                          required={true}
                                        />
                                      </div>
                                    )}
                                  </div>
                                )}
                              </>
                            ))}
                          </>
                        ))}
                      </Col>
                    </Row>
                  </Col>
                </Row>
              )}
              <Row className="mt-3">
                <Col className="d-flex justify-content-between">
                  <div>
                    {wizard > 1 && (
                      <Button
                        onClick={() => {
                          advanceStep(wizard - 1);
                        }}
                        color="primary_ghost"
                      >
                        Voltar
                      </Button>
                    )}
                  </div>
                  <div>
                    {wizard < 2 && window.location.hash === "#is_class" && (
                      <Button onClick={() => advanceStep(wizard + 1)} color="primary_ghost">
                        Avançar
                      </Button>
                    )}
                    {(wizard == 2 || window.location.hash === "#commercial" || !businessId) && (
                      <Button
                        className="ml-2"
                        onClick={() => {
                          advanceStep("save");
                        }}
                        disabled={isWaitingResponse}
                      >
                        Salvar
                      </Button>
                    )}
                  </div>
                </Col>
              </Row>
            </Form>
          </Content>
        ) : (
          <Content>
            <Loading />
          </Content>
        )}
      </Main>
      <ModalConfirm
        confirmText="Quero prosseguir assim mesmo"
        show={dateProblem}
        title={<span style={{ color: "var(--color-error)" }}>Conflitos de Data</span>}
        text={
          <>
            <p>
              A Alteração da data que você selecionou ultrapassa a data da última parcela estabelecida (
              {formatDate(dateProblem?.lastPayment, 2)}). Por favor, revise o plano financeiro da turma antes de
              prosseguir.
            </p>
            <p>Mas se você deseja prosseguir assim mesmo, preecha o campo de segurança para confirmar a sua ação.</p>
          </>
        }
        closeModal={() => {
          setdateProblem();
        }}
        colorScheme="error"
        confirm={async () => {
          dateProblem.next();
          setdateProblem();
          setacceptDateProblem(true);
        }}
      />
    </>
  );
}
